import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 bg-[#0a0e1a]" data-id="element-100">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-101">
        <FadeIn data-id="element-102">
          <div className="bg-slate-800/40 border border-slate-700/50 rounded-3xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-8 text-center md:text-left" data-id="element-103">
            <div className="shrink-0 relative" data-id="element-104">
              <div className="absolute inset-0 bg-emerald-500/20 blur-2xl rounded-full" data-id="element-105"></div>
              <ShieldCheck className="w-24 h-24 text-emerald-400 relative z-10" data-id="element-106" />
            </div>

            <div data-id="element-107">
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-108">
                Garantía de "Sueño Reparador" de 7 Días
              </h2>
              <p className="text-slate-300 text-lg leading-relaxed mb-4" data-id="element-109">
                Si aplicas el protocolo durante una semana y no notas mejoras en
                tu descanso o en tu nivel de calma antes de dormir, solo envíame
                un email dentro de los próximos 7 días y te devolveré el 100% de
                tu dinero.
              </p>
              <p className="text-emerald-400 font-bold text-lg" data-id="element-110">
                Sin preguntas. El riesgo es todo mío.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}